

function Grammar() {
    return (<div className="Page">
        <h1>Grammar page</h1>
    </div>);
}

export default Grammar;